export default "__VITE_ASSET__BaLAsyVg__"